export enum ColumnType {
  Button = 'button column',
  List = 'list column',
  Text = 'text column',
  Template = 'template column',
}
